import React from "react";
import { Link } from "react-router-dom";

export function HeroSection() {
  return (
    <section className="relative w-full min-h-[85vh] md:min-h-[90vh] overflow-hidden bg-fashion-bg-dark">
      {/* Asymmetric Background Images */}
      <div className="absolute inset-0 grid grid-cols-1 md:grid-cols-[65%_35%]">
        {/* Women (Primary focal point) */}
        <div className="relative overflow-hidden w-full h-full">
          <img
            src="/images/campaign/hero_women.png"
            alt="Women's Fashion"
            className="w-full h-full object-cover object-center scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent md:hidden" />
        </div>
        {/* Men (Secondary focal point) */}
        <div className="relative overflow-hidden hidden md:block w-full h-full border-l border-white/10">
          <img
            src="/images/campaign/hero_men.png"
            alt="Men's Fashion"
            className="w-full h-full object-cover object-center scale-105"
          />
          <div className="absolute inset-0 bg-black/30" />
        </div>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10 flex flex-col items-start justify-center h-full min-h-[85vh] md:min-h-[90vh] px-6 md:px-16 lg:px-24">
        <div className="max-w-2xl mt-auto md:mt-0 pb-16 md:pb-0">
          <p className="text-overline text-white/70 mb-4 tracking-[0.2em]">
            SPRING / SUMMER 2027
          </p>
          <h1 className="font-display text-display-xl text-white font-light leading-none mb-6 uppercase">
            The Art Of<br/>Everyday
          </h1>
          <p className="text-sm md:text-base text-white/80 font-light max-w-md mb-10 leading-relaxed">
            Refined silhouettes. Effortless presence. Designed for the moments that become your signature.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/women" className="btn-fashion btn-fashion-white px-10">
              SHOP WOMEN
            </Link>
            <Link to="/men" className="btn-fashion btn-fashion-outline border-white/50 text-white hover:border-white hover:bg-white hover:text-fashion-accent px-10">
              SHOP MEN
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
